// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .card-certificate {\n  background-color: rgba(128, 128, 128, 0.15);\n}\n", ""]);
// Exports
module.exports = exports;
